import { Box, Divider, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { colorsSelector } from '@redux/colorPalette/selectors';

const SongListTimeSeparator: React.FC = () => {
  const colors = useSelector(colorsSelector);

  return (
    <Box
      sx={{
        my: 4,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Typography
        sx={{
          position: 'absolute',
          backgroundColor: colors.remainingTimeBackground,
          py: 0.5,
          px: 3,
          borderRadius: '20px',
          display: 'flex',
          gap: '4px',
          fontWeight: 'normal',
          fontSize: '15px',
        }}
      >
        <FormattedMessage id='home.remaining-time.end-session' />
      </Typography>
      <Divider sx={{ width: 1, height: '3px', backgroundColor: colors.remainingTimeBackground }} />
    </Box>
  );
};

export default SongListTimeSeparator;
